// Revolt Magic Button Component
// Animated button with wave effects and gradient text
// Customizable colors with magical remix-style animations

import { RevoltButton } from './RevoltButton';
import { Children, cloneElement, isValidElement } from 'react';
import './RevoltMagicButton.css';

export function RevoltMagicButton({
  children,
  // Color customization props (defaults to remix purple theme)
  color1 = '#ffffff', // White
  color2 = '#9333ea', // Purple
  color3 = '#3b82f6', // Blue
  // Animation timing
  animationDuration = 3, // Text animation duration
  waveDuration = 3, // Wave/shimmer animation duration (can be different)
  // All other RevoltButton props
  ...buttonProps
}) {
  // Create CSS custom properties for dynamic colors
  const style = {
    '--magic-color-1': color1,
    '--magic-color-2': color2,
    '--magic-color-3': color3,
    '--magic-animation-duration': `${animationDuration}s`,
    '--magic-wave-duration': `${waveDuration}s`,
  };

  // Wrap text content in animated span
  const processedChildren = Children.map(children, (child) => {
    // If it's a string or number, wrap it in the animated span
    if (typeof child === 'string' || typeof child === 'number') {
      return <span className="revolt-magic-text">{child}</span>;
    }
    // If it's a React element, check if it's an icon (don't animate) or text (animate)
    if (isValidElement(child)) {
      // If it's an icon component, leave it as-is
      if (child.type?.name?.includes('Icon') || child.props?.name) {
        return child;
      }
      // For other elements, recursively process their children
      const processedChildChildren = Children.map(child.props.children, (grandChild) => {
        if (typeof grandChild === 'string' || typeof grandChild === 'number') {
          return <span className="revolt-magic-text">{grandChild}</span>;
        }
        return grandChild;
      });
      return cloneElement(child, {}, processedChildChildren);
    }
    return child;
  });

  return (
    <RevoltButton
      className="revolt-magic-btn"
      style={style}
      {...buttonProps}
    >
      {processedChildren}
    </RevoltButton>
  );
}